import { createSlice } from "@reduxjs/toolkit";
import { addRoleService, associatedRoleServices, deleteUserRole, getUserRoleService, getUserType, getUserTypeRl, getUserTypeService, removeRoleService } from "../../actions/security/userRoleAction";

const initialState = {
    loading: false,
    assProdData: null,
    error: null,
    success: false,
    //user type srvice
    loading1: false,
    utypeData: null,
    error1: null,
    success1: false,
    //user role srvice
    loading2: false,
    rTypeData: null,
    error2: null,
    success2: false,
    //user role add
    loading3: false,
    addRoleInfo: null,
    error3: null,
    success3: false,
    //user role associated services
    loading4: false,
    serviceInfo: null,
    error4: null,
    success4: false,
    //user role remove
    loading5: false,
    delUserInfo: null,
    error5: null,
    success5: false,
    //user type & role new call
    loading6: false,
    roleData: null,
    error6: null,
    success6: false,
     //remove role service
     loading7: false,
     rmvRoleInfo: null,
     error7: null,
     success7: false,

}

const userRoleSlice = createSlice({
    name: "user-roless",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getUserType.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(getUserType.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.assProdData = payload;
                state.success = true;
                state.error = null;
            })
            .addCase(getUserType.rejected, (state, { paylaod }) => {
                state.loading = false;
                state.error = paylaod;
                state.success = false;
            })
            //user type service
            .addCase(getUserTypeService.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(getUserTypeService.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.utypeData = payload;
                state.success1 = true;
                state.error1 = null;
            })
            .addCase(getUserTypeService.rejected, (state, { paylaod }) => {
                state.loading1 = false;
                state.error1 = paylaod;
                state.success1 = false;
            })
            //user role service
            .addCase(getUserRoleService.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(getUserRoleService.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.rTypeData = payload;
                state.success2 = true;
                state.error2 = null;
            })
            .addCase(getUserRoleService.rejected, (state, { paylaod }) => {
                state.loading2 = false;
                state.error2 = paylaod;
                state.success2 = false;
            })
             //user role add
             .addCase(addRoleService.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(addRoleService.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.addRoleInfo = payload;
                state.success3 = true;
                state.error3 = null;
            })
            .addCase(addRoleService.rejected, (state, { paylaod }) => {
                state.loading3 = false;
                state.error3 = paylaod;
                state.success3 = false;
            })
             //user role associated services
             .addCase(associatedRoleServices.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(associatedRoleServices.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.serviceInfo = payload;
                state.success4 = true;
                state.error4 = null;
            })
            .addCase(associatedRoleServices.rejected, (state, { paylaod }) => {
                state.loading4 = false;
                state.error4 = paylaod;
                state.success4 = false;
            })
             //user role delete
             .addCase(deleteUserRole.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
            })
            .addCase(deleteUserRole.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.delUserInfo = payload;
                state.success5 = true;
                state.error5 = null;
            })
            .addCase(deleteUserRole.rejected, (state, { paylaod }) => {
                state.loading5 = false;
                state.error5 = paylaod;
                state.success5 = false;
            })
            //user role new call
            .addCase(getUserTypeRl.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
            })
            .addCase(getUserTypeRl.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.roleData = payload;
                state.success6 = true;
                state.error6= null;
            })
            .addCase(getUserTypeRl.rejected, (state, { paylaod }) => {
                state.loading6 = false;
                state.error6 = paylaod;
                state.success6 = false;
            })
             //remove userservice
             .addCase(removeRoleService.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
            })
            .addCase(removeRoleService.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.rmvRoleInfo = payload;
                state.success7 = true;
                state.error7= null;
            })
            .addCase(removeRoleService.rejected, (state, { paylaod }) => {
                state.loading7 = false;
                state.error7 = paylaod;
                state.success7 = false;
            })
    }
});

export default userRoleSlice.reducer;